import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PAYMENT_METHODS_ENABLED_FOR = createFcmDetails('payment_methods_enabled_for', {
	owner: 'Payments',
	context: 'Payment Form',
	description: `
			Displays payment method options, sequence of payment methods in the list determines the sequence in which buttons are displayed.
			Each payment method can be configured by adding:
			- payment_method_name: Should be one of the supported payment methods ('creditCard', 'paypal', 'sepa', 'applePay', 'googlePay')
			- enabled: Controls displaying of the payment method button
			- safe_listed_user_identifiers: Overrides enabled flag to display the payment method button
			- block_listed_user_identifiers: Overrides enabled flag to hide the payment method button
		`,
	template: [
		{
			payment_method_name: 'creditCard',
			enabled: false,
			safe_listed_user_identifiers: [],
			block_listed_user_identifiers: [],
		},
		{
			payment_method_name: 'paypal',
			enabled: false,
			safe_listed_user_identifiers: [],
			block_listed_user_identifiers: [],
		},
	],
	mergeLogic: `
			Overrides enabled flag in country setting by configuring the payment method globally.'
			Example
				global: [{ payment_method_name: "paypal", enabled: false}]
				US: [{payment_method_name: "creditCard", enabled: true}, {payment_method_name: "paypal", enabled: true}]
				Merger value: [{payment_method_name: "creditCard", enabled: true}, {payment_method_name: "paypal", enabled: false}]
		`,
	import: false,
});
